import { soapToRESTFieldNames } from '@hashicorp/react-components/src/components/marketo-form/utils'
import type { Lead } from 'app/api/fetch-marketo-lead/route'

export const LEAD_ID_URL_PARAM = 'id'
export const LEAD_EMAIL_URL_PARAM = 'email'

// Some fields return `[[unknown]]` when they are not set. We want to ignore these fields when initializing the form.
const checkUnknown = (item: string | null | Date | number) => {
	if (typeof item === 'string') {
		return item === '[[unknown]]' || item === '[not provided]'
	}

	return true
}

const restKeys = Object.values(soapToRESTFieldNames)

// The initialValues prop for the form should be in SOAP format, but the Marketo leads API uses REST format.
// This function converts the lead data from REST to SOAP format so that the form can be initialized correctly.
export const convertLeadToSoapFields = (lead: Lead) => {
	const soapData = {}
	for (const [restKey, value] of Object.entries(lead)) {
		if (!checkUnknown(value) && restKeys.indexOf(restKey) >= 0) {
			const soapKey = Object.keys(soapToRESTFieldNames).find((soapKey) => {
				return soapToRESTFieldNames[soapKey] === restKey
			})
			soapData[soapKey] = value
		}
	}
	return soapData
}
